export default __webpack_public_path__ + "static/media/CommunityTab.00da8ff1.svg";